import React from "react";
import { Box } from "@mui/material";
import { ChatMessagesContainer } from "../../styles";
import { ChatMessage } from "../../types";
import MessageUser from "./MessageUser";
import MessageDumont from "./MessageDumont";
import MessageDumontDispatch from "./MessageDumontDispatch";
import DispatchWelcome from "./DispatchWelcome";

export default function MessagesList({ messages, endRef, isFullscreen }: { messages: ChatMessage[]; endRef: React.Ref<HTMLDivElement>; isFullscreen?: boolean }) {
  if (!messages.length) return null;
  
  const showWelcome = messages.length > 0 && messages[0].showWelcome;
  
  const renderMessage = (m: ChatMessage, index: number) => {
    if (m.sender === "user") {
      return <MessageUser text={m.text} />;
    }
    
    if (m.dispatchData) {
      return <MessageDumontDispatch orders={m.dispatchData} />;
    }
    
    return <MessageDumont text={m.text} isLoading={m.isLoading} />;
  };
  
  if (isFullscreen) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {showWelcome && (
          <Box sx={{ display: "flex", justifyContent: "center", marginBottom: "28px" }}>
            <DispatchWelcome />
          </Box>
        )}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {messages.map((m, index) => (
            <React.Fragment key={m.id}>{renderMessage(m, index)}</React.Fragment>
          ))}
        </Box>
        <div ref={endRef} />
      </Box>
    );
  }
  
  return (
    <ChatMessagesContainer>
      {showWelcome && (
        <Box sx={{ display: "flex", justifyContent: "center", marginBottom: "28px" }}>
          <DispatchWelcome />
        </Box>
      )}
      {messages.map((m, index) => (
        <React.Fragment key={m.id}>{renderMessage(m, index)}</React.Fragment>
      ))}
      <div ref={endRef} />
    </ChatMessagesContainer>
  );
}


